module.exports = __webpack_public_path__ + "static/dwarf_female_cleric_knowledge_PHB-11b4c99aa33b6161722da369b482346c.png";